import { Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBullseye } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import { normalizeLessonContent } from "../utils/lessonContent.utils"

// Sotto i nomi, nella scheda chiusa, l'obiettivo del programma (#214): una
// riga sola, tagliata se è lunga, col bersaglio del riquadro Programma. Dice
// cosa si fa in quella lezione, che è quello che un'icona "c'è il
// programma" faceva solo indovinare. Senza obiettivo non c'è, e la scheda è
// alta come sempre.
function LessonObjective({ lessonData }) {
	const { objective } = normalizeLessonContent(lessonData.lessonContent)
	if (!objective) return null

	return (
		<Text
			d="flex"
			align="center"
			textSize="caption"
			textColor={theme.colors.text_light}
			m={{ t: "-0.3rem", b: "0.6rem" }}
			style={{ gap: "0.4rem", minWidth: 0 }}>
			<FontAwesomeIcon icon={faBullseye} />
			<span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
				{objective}
			</span>
		</Text>
	)
}

export default LessonObjective
